import { render, staticRenderFns } from "./ThanksEng.vue?vue&type=template&id=2f2e3896&scoped=true"
import script from "./ThanksEng.vue?vue&type=script&lang=js"
export * from "./ThanksEng.vue?vue&type=script&lang=js"
import style0 from "./ThanksEng.vue?vue&type=style&index=0&id=2f2e3896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e3896",
  null
  
)

export default component.exports